import axios from '@/utils/axios'

// 获取轮播图
const getCarouseList = (type = "4", query, config) => axios.get(`/api/v1/pc/home/carouse/${type}`, query, config)
// 获取活动列表
const getSpecialArea = (query, config) => axios.get('/api/v1/pc/home/specialArea', query, config)
// 轮播图下首个活动商品列
const indexSpecialArea = (
  specialAreaId = '1903281448311517', query, config
) => axios.get(`/api/v1/pc/home/specialArea/goods/${specialAreaId}`, query, config)
const specialAreaList = (query = {}, config) => axios.get("/api/v1/pc/home/specialAreaList", query, config)

const getDisplayClassifyAndGoods = (query = {}, config) => axios.get("/api/v1/pc/home/displayClassifyAndGoods", query, config)

export default {
  getCarouseList,
  getSpecialArea,
  indexSpecialArea,
  specialAreaList,
  getDisplayClassifyAndGoods,
}



// WEBPACK FOOTER //
// ./src/api/modules/home.js